import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { restartableTask, timeout } from 'ember-concurrency';
import { EVENTS } from 'sh-www/constants/environment';

class SignoutRoute extends Route {
  @service
  session;

  activate() {
    this.logout.perform();
  }

  @restartableTask
  *logout() {
    try {
      yield timeout(1);
      yield this.session.invalidate();
    } finally {
      window.ReactNativeWebView?.postMessage(`{ "type": "${EVENTS.USER_LOGGED_OUT}" }`);
      location.replace('/signin?from=logout');
    }
  }
}

export default SignoutRoute;
